<!-- <div class="lg:container relative z-10 pt-6 px-5"> -->
  <bit-header></bit-header>
<!-- </div> -->

<div class="w-full lg:mt-0 lg:h-[calc(100vh-104px)] h-[calc(100vh-53px)] relative" #treemap_container>
  <div class="multi-select w-44 mb-4 absolute top-11 right-10 z-10 bg-zinc-900">
    <div class="selection" (click)="getMarket('IRT')" i18n>پایه تومان</div>
    <div class="selection" (click)="getMarket('USDT')" i18n>پایه تتر</div>
    <div class="active-selection" [style.--selected-index]="baseMarket === 'IRT' ? 0 : 1"></div>
  </div>
  <bit-heatmap
    *ngIf="baseMarket === 'IRT'"
    [quoteCurrencyId]="baseMarket"
    [treemapData]="market$"
    [newData$]="newMarketData"
    [width]="treemap_container.clientWidth"
    [height]="treemap_container.clientHeight"
    [isFullScreen]="false">
  </bit-heatmap>
  <bit-heatmap
    *ngIf="baseMarket === 'USDT'"
    [quoteCurrencyId]="baseMarket"
    [treemapData]="market$"
    [newData$]="newMarketData"
    [width]="treemap_container.clientWidth"
    [height]="treemap_container.clientHeight"
    [isFullScreen]="false">
  </bit-heatmap>
</div>
